import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  section: {
    marginTop: 20,
  },
  sectionTitle: {
    marginBottom: 20,
    color: "#465869",
    fontSize: 16,
    fontFamily: "'Manrope', sans-serif",
    lineHeight: "18px",
    fontWeight: "bold",
  },
}));

export default styles;
